/** @format */

import {Mutable} from 'types';

import {GraphSensorCheckType} from '../../types';

const combineByCollectedOn = (
  data: ReadonlyArray<GraphSensorCheckType>,
): GraphSensorCheckType[] => {
  const combinedData: Record<string, Mutable<GraphSensorCheckType>> = {};

  data.forEach(item => {
    const {collectedOn, fixed, new: newValue, old, sensorName} = item;

    if (!combinedData[collectedOn]) {
      combinedData[collectedOn] = {
        collectedOn,
        fixed: 0,
        new: 0,
        old: 0,
        sensorName,
      };
    }

    combinedData[collectedOn].fixed += fixed;
    combinedData[collectedOn].new += newValue;
    combinedData[collectedOn].old += old;
  });

  return Object.values(combinedData);
};

export {combineByCollectedOn};
